export default "__VITE_ASSET__B4J1Pj38__"